export const CARTOGRAPHER_PLOTS = "cartographer-plots";
